export const convertSmartChars = function(value) {
    if (!value) return value
    value = value.replaceAll('\u2013', '-')
    value = value.replaceAll('\u2014', '-')
    value = value.replaceAll('\u2015', '-')
    value = value.replaceAll('\u2017', '_')
    value = value.replaceAll('\u2018', '\'')
    value = value.replaceAll('\u2019', '\'')
    value = value.replaceAll('\u201a', ',')
    value = value.replaceAll('\u201b', '\'')
    value = value.replaceAll('\u201c', '\"')
    value = value.replaceAll('\u201d', '\"')
    value = value.replaceAll('\u201e', '\"')
    value = value.replaceAll('\u201f', '\"')
    value = value.replaceAll("\u2026", "...")
    value = value.replaceAll('\u2032', '\'')
    value = value.replaceAll('\u2033', '\"')
    value = value.replaceAll('\u00bc','1/4')
    value = value.replaceAll('\u00bd','1/2')
    value = value.replaceAll('\u00be','3/4')
    value = value.replaceAll('\u2150','1/7')
    value = value.replaceAll('\u2151','1/9')
    value = value.replaceAll('\u2152','1/10')
    value = value.replaceAll('\u2153','1/3')
    value = value.replaceAll('\u2154','2/3')
    value = value.replaceAll('\u2155','1/5')
    value = value.replaceAll('\u2156','2/5')
    value = value.replaceAll('\u2157','3/5')
    value = value.replaceAll('\u2158','4/5')
    value = value.replaceAll('\u2159','1/6')
    value = value.replaceAll('\u215a','5/6')
    value = value.replaceAll('\u215b','1/8')
    value = value.replaceAll('\u215c','3/8')
    value = value.replaceAll('\u215d','5/8')
    value = value.replaceAll('\u215e','7/8')
    value = value.replaceAll('\u2189','0/3')

    return value
}

export const snakeCaseToKebabCase = function(value) {
    return value?.replaceAll("_", "-")
}
